<ng-template #introText>
    @if (introductionText) {
        <div
            bigSharedComputeInnerHtmlLinks
            [innerHTML]="introductionText | sanitize: securityContext"
            [class]="{
                hidden: !isFirstFormPage(),
                'h-0': !isFirstFormPage(),
                'md:block': !isFirstFormPage(),
                'md:opacity-0': !isFirstFormPage(),
                'text-primary-500': isFirstFormPage(),
                'dark:text-white': isFirstFormPage(),
            }"
            class="[&_>*:last-child]:mb-0"></div>
    }
</ng-template>

@if (!isFormShown()) {
    @if (node) {
        @if (node.breadcrumbs?.length) {
            <div class="hide-in-mobile-app container mt-6 print:hidden">
                <big-ui-breadcrumb [entries]="node.breadcrumbs!" />
            </div>
        }

        <div
            class="hide-in-mobile-app container print:hidden"
            [class.mt-20]="!isHome()"
            [class]="headerBottomSpacing()">
            @if (!showWizard()) {
                @if ((!isHome() && node.heading) || node.introduction || node.publicationDate || node.publicationLocation) {
                    <div
                        class="grid grid-cols-12 lg:gap-8"
                        [class]="{
                            'mb-6': !isDashboard(),
                            'md:mb-8': !isDashboard(),
                            'lg:mb-10': !isDashboard(),
                        }">
                        <div
                            [class.mb-4]="isDashboard()"
                            class="col-span-12 lg:col-span-10">
                            <big-ui-introduction />
                        </div>
                    </div>
                }

                @if (node.newsIntroductionImage) {
                    <big-ui-picture
                        class="mb-8 block"
                        [model]="node.newsIntroductionImage" />
                }

                @if (showPageTitle() && node.pageTitle) {
                    <big-ui-page-title
                        [model]="node.pageTitle"
                        [class]="{
                            '-mx-4': isHome(),
                            'md:mx-0': isHome(),
                        }" />
                }

                @if (isHome() && node.heading) {
                    <div class="mt-16 grid grid-cols-12 md:mt-20 lg:mt-30 lg:gap-8">
                        <h1 class="col-span-12 mb-0 lg:col-span-10">
                            {{ node.heading }}
                        </h1>
                    </div>
                }
            }
        </div>
    }
} @else {
    <big-nav-form-header [heading]="node.heading">
        <ng-template [ngTemplateOutlet]="introText"></ng-template>
    </big-nav-form-header>
}

<div
    [class]="{
        container: showWizard(),
        grid: showWizard(),
        'grid-cols-12': showWizard(),
        'gap-6': showWizard(),
        '[&_big-form-holder]:container': !showWizard(),
    }">
    @if (showWizard()) {
        <div class="col-span-3 hidden md:block">
            <big-form-wizard class="mb-16" />
        </div>
    }
    <main
        [class]="{
            'col-span-12': showWizard(),
            'md:col-span-8': showWizard(),
            'md:col-start-5': showWizard(),
        }">
        @if (node.hasDirectory) {
            <div class="container mb-16 md:mb-20 lg:mb-30">
                <big-directory
                    [paragraphs]="node.paragraphs"
                    [directoryParagraphs]="node.directoryParagraphs" />
            </div>
        }

        @if (node.paragraphs) {
            <big-paragraphs-holder
                [data]="node.paragraphs"
                [class.no-margin-top]="showWizard()" />
        }

        @if (showAuthorBox()) {
            <div class="container mt-16 md:mt-20 lg:mt-30">
                <div class="grid grid-cols-12 md:gap-8">
                    <div class="col-span-12 md:col-span-8">
                        <big-author-box
                            [name]="node.author?.name"
                            [description]="node.author?.description"
                            [image]="node.author?.image" />
                    </div>
                </div>
            </div>
        }
    </main>
</div>
